module.exports = __webpack_public_path__ + "static/media/package.2756845a.svg";